<template>
  <div>
    <div id="details">
      <br />
      <b-row>
        <!-- Left Side -->
        <b-col sm="6">
          <b-row align-v="end">
            <b-col sm="4">
              <label>Case ID</label>
            </b-col>
            <b-col class="underline" sm="8">
              <div id="idDetailsCaseNumber">{{ this.surgicalCase.metadata.surgicalCaseId }}</div>
            </b-col>
          </b-row>
          <b-row align-v="end">
            <b-col sm="4">
              <label>Status</label>
            </b-col>
            <b-col class="underline" sm="8">
              <div
                id="idDetailsStatus"
              >{{ this.surgicalCase.metadata.commentedCaseState.surgicalCaseState }}</div>
            </b-col>
          </b-row>
          <b-row align-v="end">
            <b-col sm="4">
              <label>Division</label>
            </b-col>
            <b-col class="underline" sm="8">
              <div id="idDetailsDivision">{{ this.surgicalCase.division }}</div>
            </b-col>
          </b-row>
          <b-row align-v="end">
            <b-col sm="4">
              <label>Branch</label>
            </b-col>
            <b-col class="underline" sm="8">
              <div id="idDetailsBranch">{{ branch }}</div>
            </b-col>
          </b-row>
          <b-row align-v="end">
            <b-col sm="4">
              <label>Hospital No- Name</label>
            </b-col>
            <b-col class="underline" sm="8">
              <div id="idDetailsHospitalName">{{ hospitalName }}</div>
            </b-col>
          </b-row>
          <b-row align-v="end">
            <b-col sm="4">
              <label>Surgeon No- Name</label>
            </b-col>
            <b-col class="underline" sm="8">
              <div id="idDetailsSurgeonName">{{ surgeonName }}</div>
            </b-col>
          </b-row>
          <b-row align-v="end">
            <b-col sm="4">
              <label>Covering Reps</label>
            </b-col>
            <b-col class="underline" sm="8">
              <div id="idDetailsCoveringReps">{{ coveringReps }}</div>
            </b-col>
          </b-row>
          <b-row align-v="end">
            <b-col sm="4">
              <label>Procedure</label>
            </b-col>
            <b-col class="underline" sm="8">
              <div id="idDetailsProcedure">{{ this.surgicalCase.procedure }}</div>
            </b-col>
          </b-row>
          <b-row align-v="end">
            <b-col sm="4">
              <label>Surgery Start Date Time</label>
            </b-col>
            <b-col class="underline" sm="8">
              <div id="idDetailsSurgeryStartDate">{{ surgeryDate }}</div>
            </b-col>
          </b-row>
          <b-row align-v="end">
            <b-col sm="4">
              <label>Delivery Date</label>
            </b-col>
            <b-col class="underline" sm="8">
              <div id="idDeliveryDate"></div>
            </b-col>
          </b-row>
          <b-row align-v="end">
            <b-col sm="4">
              <label>Shipping Address</label>
            </b-col>
            <b-col class="underline" sm="8">
              <div id="idShippingAddress"></div>
            </b-col>
          </b-row>
        </b-col>
        <!-- Left Side End-->
        <!-- Right Side -->
        <b-col sm="6">
          <b-row align-v="end">
            <b-col sm="4">
              <label>Patient ID</label>
            </b-col>
            <b-col class="underline" sm="8">
              <!-- TODO: add Patient ID-->
              <div id="idDetailsPatientID">{{ this.surgicalCase.patientId }}</div>
            </b-col>
          </b-row>
          <b-row align-v="end">
            <b-col sm="4">
              <label>Right</label>
            </b-col>
            <b-col class="underline" sm="8">
              <b-form-checkbox
                id="idDetailsRight"
                style="float: left"
                :checked="this.surgicalCase.operativeSide === 'right'"
                disabled
              />
            </b-col>
          </b-row>
          <b-row align-v="end">
            <b-col sm="4">
              <label>Left</label>
            </b-col>
            <b-col class="underline" sm="8">
              <b-form-checkbox
                id="idDetailsLeft"
                style="float: left"
                :checked="this.surgicalCase.operativeSide === 'left'"
                disabled
              />
            </b-col>
          </b-row>
          <b-row align-v="end">
            <b-col sm="4">
              <label>Mako</label>
            </b-col>
            <b-col class="underline" sm="8">
              <b-form-checkbox id="idDetailsMako" style="float: left;" checked="true" disabled />
            </b-col>
          </b-row>
          <b-row align-v="end">
            <b-col sm="4">
              <label>Revision</label>
            </b-col>
            <b-col class="underline" sm="8">
              <b-form-checkbox
                id="idDetailsRevision"
                style="float: left;"
                :checked="this.surgicalCase.revision"
                disabled
              />
            </b-col>
          </b-row>
          <b-row align-v="end">
            <b-col sm="4">
              <label>Add-On</label>
            </b-col>
            <b-col class="underline" sm="8">
              <div id="idDetailsAddOn">&nbsp;</div>
            </b-col>
          </b-row>
          <b-row align-v="end">
            <b-col sm="4">
              <label>PO Uploaded</label>
            </b-col>
            <b-col class="underline" sm="8">
              <b-form-checkbox
                id="idDetailsPoUploaded"
                style="float: left;"
                checked="false"
                disabled
              />
            </b-col>
          </b-row>
          <b-row align-v="end">
            <b-col sm="4">
              <label>Case Type</label>
            </b-col>
            <b-col class="underline" sm="8">
              <div id="idDetailsCaseType">Info Only</div>
            </b-col>
          </b-row>
          <b-row align-v="end">
            <b-col sm="4">
              <label>Usage Reject Comments</label>
            </b-col>
            <b-col class="underline" sm="8">
              <div id="idDetailsUsageRejectComments"></div>
            </b-col>
          </b-row>
          <b-row align-v="end">
            <b-col sm="4">
              <label>Internal Comments</label>
            </b-col>
            <b-col class="underline" sm="8">
              <div id="idDetailsInternalComments">{{this.surgicalCase.internalComments}}</div>
            </b-col>
          </b-row>
          <b-row align-v="end">
            <b-col sm="4">
              <label>Cancel Reason</label>
            </b-col>
            <b-col class="underline" sm="8">
              <div id="idDetailsCancelReason">{{ this.cancelReason }}</div>
            </b-col>
          </b-row>
          <b-row align-v="end">
            <b-col sm="4">
              <label>Cancel Comment</label>
            </b-col>
            <b-col class="underline" sm="8">
              <div id="idDetailsCancelComment"></div>
            </b-col>
          </b-row>
          <b-row align-v="end">
            <b-col sm="4">
              <label>Delivery Options</label>
            </b-col>
            <b-col class="underline" sm="8">
              <div id="idDetailsDeliveryOptions"></div>
            </b-col>
          </b-row>
        </b-col>
        <!-- Right Side End-->
      </b-row>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import _ from "lodash";

export default {
  props: ["surgicalCase"],
  computed: {
    cancelReason() {
      if (
        this.surgicalCase.metadata.commentedCaseState.surgicalCaseState ===
        "Cancelled"
      )
        return this.surgicalCase.metadata.commentedCaseState.comment;
      else return "";
    },
    surgeryDate() {
      return moment(this.surgicalCase.surgeryStartDateTime).format(
        "M/D/YYYY, h:mm A"
      );
    },
    branch() {
      return (
        this.surgicalCase.branchNumber + " - " + this.surgicalCase.branchName
      );
    },
    hospitalName() {
      if (_.some(this.surgicalCase.hospitalName, _.isNotEmpty))
        return (
          this.surgicalCase.hospitalNumber +
          " - " +
          this.surgicalCase.hospitalName
        );
      else return "";
    },
    surgeonName() {
      if (_.some(this.surgicalCase.surgeon, _.isNotEmpty)) {
        return (
          this.surgicalCase.surgeon.email +
          " - " +
          this.surgicalCase.surgeon.firstName +
          " " +
          this.surgicalCase.surgeon.lastName
        );
      } else return "";
    },
    coveringReps() {
      var reps = "";
      this.surgicalCase.coveringReps.forEach((rep) => {
        reps += rep.firstName;
        reps += " ";
        reps += rep.lastName;
        reps += ", ";
      });
      reps = reps.slice(0, -2);
      return reps;
    }
  }
};
</script>

<style scoped>
.custom-checkbox.b-custom-control-lg,
.input-group-lg .custom-checkbox {
  position: absolute;
  bottom: 1.5rem;
}
.underline {
  border-bottom: 1px solid #d3d3d3;
  text-align: left;
}
.row {
  margin: 0.2rem 0;
}
label {
  margin-bottom: 0;
  margin-top: 8px;
}
</style>
